<agpr-dialog-container
    id="editRecipientDialog"
    [heading]="(
        isCreate
        ? 'Common.mailingLists.editRecipientDialog.heading.create'
        : 'Common.mailingLists.editRecipientDialog.heading.edit'
    )"
    (close)="cancel()"
>
    <div
        [agprLoading]="loading"
        class="agpr-editRecipientDialog-content"
    >
        <agpr-text-input
            [id]="'editRecipientDialog.name'"
            label="Common.mailingLists.editRecipientDialog.name.label"
            placeholder="Common.mailingLists.editRecipientDialog.name.placeholder"
            maxLength="32"
            [initialFocus]="true"
            [(ngModel)]="value.name"
        ></agpr-text-input>
        <agpr-text-input
            [id]="'editRecipientDialog.email'"
            label="Common.mailingLists.editRecipientDialog.email.label"
            placeholder="Common.mailingLists.editRecipientDialog.email.placeholder"
            maxLength="128"
            [required]="true"
            [ariaInvalid]="value.email && emailFormatInvalid"
            ariaDescribedBy="editRecipientDialog_invalidEmailMessage"
            [bottomMargin]="false"
            [(ngModel)]="value.email"
            (ngModelChange)="validateEmailFormat()"
        ></agpr-text-input>
        <agpr-form-message
            *ngIf="value.email && emailFormatInvalid"
            id="editRecipientDialog_invalidEmailMessage"
        >
            {{ 'Common.mailingLists.editRecipientDialog.email.error.format' | localize }}
        </agpr-form-message>
    </div>
    <ng-template #footerLeft>
        <agpr-button
            id="editRecipientDialog.cancel"
            label="Core.button.cancel"
            [disabled]="loading"
            (click)="cancel()"
        >
        </agpr-button>
    </ng-template>
    <ng-template #footerRight>
        <agpr-button
            id="editRecipientDialog.ok"
            ariaLabel="isCreate ? 'Common.mailingLists.editRecipientDialog.ok.create' : 'Common.mailingLists.editRecipientDialog.ok.edit'"
            [label]="isCreate ? 'Common.mailingLists.editRecipientDialog.ok.create' : 'Common.mailingLists.editRecipientDialog.ok.edit'"
            [style]="buttonTypes.primary"
            [disabled]="!value.email || emailFormatInvalid || loading"
            [tooltip]="!value.email
            ? 'Common.mailingLists.editRecipientDialog.email.required'
            : (emailFormatInvalid
                ? 'Common.mailingLists.editRecipientDialog.email.error.format'
                : '')
            "
            [ariaDescribedBy]="!value.email
            ? 'editRecipientDialog_requiredEmailMessage'
            : (emailFormatInvalid
                ? 'editRecipientDialog_invalidEmailMessage'
                : '')
            "
            (click)="ok()"
        ></agpr-button>
        <span *ngIf="!value.email" class="u-srOnly"  id="editRecipientDialog_requiredEmailMessage">
            {{'Common.mailingLists.editRecipientDialog.email.required' | localize }}
        </span>
    </ng-template>
</agpr-dialog-container>
